import React, { useEffect, useState } from 'react';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
    MoreOutlined,
    ExportOutlined,
} from '@ant-design/icons';
import { Avatar, Dropdown, Layout, Menu, Button } from 'antd';
import Icon from '@ant-design/icons';
import IcoTablePng from '../../assets/img/table.png';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';

const { Header, Sider, Content } = Layout;

const getItem = (label, key, icon, children, type) => {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
};

const avatarItems = [
    getItem('Cerrar sesión', 'sub-cerrar-sesion', <ExportOutlined />),
];

const SiteLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const { session, logout } = useAuth();
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (session) {
            const menu = session.user.menu;
            let tempItems = [];

            for (const m of menu) {
                // Genera el sub-menú
                let tempChildren = m.submenu.map((item) =>
                    getItem(
                        <Link to={item.url}>{item.nombre}</Link>,
                        `${item.idMenu}-${item.idSubmenu}`
                    )
                );

                // Agrega separador entre cada sub-menú
                tempChildren = tempChildren
                    .map((item) => [
                        item,
                        {
                            type: 'divider',
                        },
                    ])
                    .flat();

                // Genera menú
                const item = getItem(
                    m.nombre,
                    m.idMenu,
                    <Icon
                        component={() => (
                            <img src={IcoTablePng} height='20' alt={m.nombre} />
                        )}
                    />,
                    tempChildren
                );

                tempItems.push(item);
            }

            setItems(tempItems);
        }
    }, [session]);

    const handleAvatarMenuClick = (e) => {
        switch (e.key) {
            case 'sub-cerrar-sesion':
                logout();

                break;
            default:
                break;
        }
    };

    return (
        <Layout className='site-layout'>
            <Sider trigger={null} collapsible collapsed={collapsed}>
                <div className='demo-logo-vertical' />
                <Menu
                    theme='dark'
                    mode='inline'
                    items={items}
                    defaultSelectedKeys={['sub-mantenedores']}
                />
            </Sider>
            <Layout>
                <Header className='p-0'>
                    <div className='header-top ms-0'>
                        <div className='d-flex'>
                            <Button
                                type='text'
                                icon={
                                    collapsed ? (
                                        <MenuUnfoldOutlined />
                                    ) : (
                                        <MenuFoldOutlined />
                                    )
                                }
                                onClick={() => setCollapsed(!collapsed)}
                                className='text-white'
                                style={{
                                    fontSize: '16px',
                                    width: 64,
                                    height: 64,
                                }}
                            />

                            <div className='title-left text-uppercase'>
                                <h3 className='m-0'>Bienvenidos a LEFI</h3>
                            </div>
                        </div>

                        <div className='avatar-menu'>
                            <ul className='d-flex m-0'>
                                <li className='mt-2'>
                                    <Dropdown
                                        menu={{
                                            items: avatarItems,
                                            onClick: handleAvatarMenuClick,
                                        }}
                                        trigger={['click']}
                                        arrow
                                    >
                                        <MoreOutlined
                                            style={{ fontSize: '30px' }}
                                        />
                                    </Dropdown>
                                </li>
                                <li>
                                    <Avatar size={40} icon={<UserOutlined />} />
                                </li>
                                <li className='ms-2'>
                                    <span>
                                        {session ? session.user.givenName : ''}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Header>

                <Content
                    style={{
                        margin: '16px 16px',
                        padding: 2,
                        minHeight: 280,
                        // background: colorBgContainer,
                        // borderRadius: borderRadiusLG,
                    }}
                >
                    {/* <div className='layout-content'> */}
                    <div>
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default SiteLayout;
